import config from '../../config';
import { request } from '../../libraries/request'

const getAll = (params = {}, token) => {
  //console.log('SERVICES::MESSAGES::get', params, token);
  if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) { 
    params.order_by = 'messages__created_at';
  }
  if (!params.order_direction) {
    params.order_direction = 'ASC';
  }

  return request({
    url: config.BASE_API_URL + config.API.MESSAGES,
    accessToken: token,
    data: params,
  })
  .then(response => {
    //console.log('RETURN FROM API', response);
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

const save = (data, token) => {
  console.log('SERVICES::MESSAGES::save', data, token);
  return request({
    url: config.BASE_API_URL + config.API.MESSAGES,
    accessToken: token,
    method: 'POST',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const update = (data, token) => {
  console.log('SERVICES::MESSAGES::update', data, token);
  return request({
    url: config.BASE_API_URL + config.API.MESSAGE.replace('{id}', data.id),
    accessToken: token,
    method: 'PATCH',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const get = (id, token) => {
  console.log('SERVICES::MESSAGES::get', id, token);
  return request({
    url: config.BASE_API_URL + config.API.MESSAGE.replace('{id}', id),
    accessToken: token,
    // data: {},
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })

}

const del = (id, token) => {
  console.log('SERVICES::MESSAGES::remove', id, token);
  return request({
    url: config.BASE_API_URL + config.API.MESSAGE.replace('{id}', id),
    accessToken: token,
    method: 'DELETE',
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

export default {
  getAll,
  save,
  get,
  del,
  update,
};